<template>
  <span class="regular-12 text-black text-start">
    <router-link
      class="btn btn-secondary btn-sm"
      :to="`/finance/payments/${main ?? id}`"
    >
      <BaseIcon name="wallet-empty" />
    </router-link>
  </span>
</template>

<script>
import { defineAsyncComponent } from "vue";
const BaseIcon = defineAsyncComponent(() => import("../../icons/BaseIcon.vue"));
export default {
  name: "ShowPaymentsButton",
  components: { BaseIcon },
  props: {
    id: Number,
    main: Number,
    type: String,
    row: Object,
    modelValue: String,
  },
  data() {
    return {
      show: false,
      value: this.modelValue,
    };
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change");
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
